import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import api from './api/index.js'
import config from './api/config.js'
import filters from './common/filters.js'

import { i18n } from './lang'


Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key]);
});

Vue.prototype.$api = api
Vue.prototype.$config = config

// Vue.use(ElementUI)
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value), // 这里会根据选的语言切换Element-ui的语言
})

Vue.prototype.openLoading = function() {
  const loading = this.$loading({           // 声明一个loading对象
    lock: true,                             // 是否锁屏
    text: '加载中...',                     // 加载动画的文字
    spinner: 'el-icon-loading',             // 引入的loading图标
	
    background: 'rgba(0, 0, 0, 0.3)',       // 背景颜色
    target: '.sub-main',                    // 需要遮罩的区域
    body: true,                              
    customClass: 'mask'                     // 遮罩层新增类名
  })
  setTimeout(function () {                  // 设定定时器，超时6S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
    loading.close();                        // 关闭遮罩层
  },6000)
  return loading;
}


Vue.config.productionTip = false

new Vue({
	router,
	i18n,
	render: h => h(App)
}).$mount('#app')
